<template>
    <div>
        <div id="scene" >
            <div  class="lo-studio-legale absolute-center" v-if="this.dataLoaded">
                <div class="bg-image-container" >
                    <div class="bg-image"
                    data-aos="animation-background-picture"
                    data-aos-duration="3000"
                    ></div>
                </div>
                <div class="container">
                    <div> 
                        <!-- <h1 v-html="this.page.attributes.field_description.processed"></h1> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'section-lo-studio-legale',
    props: {
        dataPages: {
            type: String
        }
    },
    data:()=>{
        return {
            idIntroPage:"13ffa483-7745-4f53-b4a6-3da66b978d22",
            page:[],
            dataLoaded:true,
            customClass:false,
            scrollIns: null
        }
    },
    methods:{
        findObjectbyKey:(array, key, value)=>{
            for (var i = 0; i < array.length; i++) {
                if (array[i][key] === value) {
                    return array[i];
                }
            }
            return null;
        },
    },
    mounted(){
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.lo-studio-legale {
    width: 100%;
    height: 65vh;
    position: relative;
    .container {
        padding: 0px 10rem;
    }
    h1, h1 p{
        font-family: "Playfair Display";
        text-align: center;
        color: #fff;
        font-size: 2.5rem;
        line-height: 1.3em;
    }
}
.lo-studio-legale{
    overflow: hidden; 
    .bg-image {
    background: url("../assets/sez-bg.png") center no-repeat;
    background-size:cover;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: -1;
}}


@media (max-width:992px){
.lo-studio-legale h1, .lo-studio-legale h1 p {
    font-size: 2rem;
    
}
.lo-studio-legale .container {
    padding: 0px 0rem;
}
}
@media (max-width:768px){
    .lo-studio-legale .container {
        padding: 0px 1rem;
        h1, h1 p{
            font-size: 1.4rem;
        }
    }
}
</style>
